<!--  -->
<template>
        <div v-show="show" style="height:90%;">
        <div style="margin-bottom:10px;display:flex;justify-content:flex-start;">
          <el-button  type="success" icon="el-icon-plus" @click="addBackImgData()" plain>添加首页背景图</el-button>
          <el-button  type="success" icon="el-icon-plus" @click="addData()" plain>添加数据</el-button>
          <div style="width:300px;display:flex;justify-content:space-between;margin-left:20px">
            <el-input style="margin-right:10px" v-model="condition.title" placeholder="请输入内容"></el-input> <el-button type="success" size="mini" @click="queryByTitle()" round>搜索</el-button>
          </div>
        </div>
        <el-popconfirm
                confirm-button-text='确定'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="red"
                @confirm="deletedIds()"
                title="确定删除该组数据吗？">
          <el-button style="margin-bottom:10px" v-show="ids.length>0"   type="danger" icon="el-icon-delete" slot="reference" plain>删除该组数据</el-button>
          </el-popconfirm>
          <el-table
            :data="tableData.list"
            @selection-change="handleSelectionChange"
            @filter-change="filterMethod"
            @sort-change="sortChange"
            style="width: 100%;height:85%;overflow: scroll;">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              label="背景图"
              width="180">
              <template slot-scope="scope">
                <el-image style="width: 150px; height: 100px" :src="scope.row.backImg" fit="scale-down"></el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              width="180">
            </el-table-column>
            <el-table-column
              prop="num"
              label="浏览次数"
              sortable
              width="180">
            </el-table-column>
            <el-table-column
              prop="ifshow"
              label="是否展示"
              :filters="[{text:'展示',value:true},{text:'未展示',value:false}]"
              filter-placement="bottom-end"
              :filter-multiple="false"
              column-key="ifshow"
              width="180">
              <template slot-scope="scope">
                <el-switch
                  :value="scope.row.ifshow"
                  @change="changeDisplay(scope.$index)"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="发布时间"
              width="200"
              sortable
              >
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  style="margin-right:10px"
                  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-popconfirm
                confirm-button-text='确定'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="red"
                @confirm="handleDelete(scope.$index, scope.row)"
                title="确定删除吗？">
                <el-button
                size="mini"
                type="danger"
                slot="reference">删除</el-button>
               </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            style="margin-top:10px"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="tableData.totalCount"
            :page-size="tableData.pageSize"
            >
          </el-pagination>
          <el-dialog title="编辑" :visible.sync="dialogFormVisible" width="25%" append-to-body>
            <el-form >
              <el-form-item label="id" label-width="120px" v-show="false">
                <el-input v-model="backImg.id"></el-input>
              </el-form-item>
              <el-form-item label="展示图片" label-width="120px">
                <s-upload-img :getImageUrl="getBackImg" :url="backImg.backImg"></s-upload-img>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="submitBackImg()">确 定</el-button>
            </div>
          </el-dialog>
        </div>
</template>

<script>

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {queryList,update,deleted,queryBackImg,insertBackImg,deletedIds} from '@/api/admin/brandInformation.js'
import sUploadImg from '@/components/SingleImgUpload'
export default {
//import引入的组件需要注入到对象中才能使用
components: {sUploadImg},
data() {
//这里存放数据
return {
 show:false,
 dialogFormVisible:false,
 backImg:{
  id:"",
  backImg:""
 },
 filterDisplay:[],
 condition:{
  current:1,
  size:5,
  title:"",
  ifDisplay:2,
  createTimeSort:"desc",
  clickNumSort:"desc"
 },
 tableData:{
  totalCount:1,
  pageSize:1,
  totalPage:1,
  currPage:1,
  list:[]
 },
 ids:[]//删除的列表组
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
      handleSelectionChange(val) {
        var ids = []
        for(var i=0;i<val.length;i++){
          ids.push(val[i].id)
        }
        this.ids=ids
      },
      addBackImgData(){
        var _this = this
        _this.dialogFormVisible = true
         queryBackImg().then(({data})=>{
           _this.backImg.id = data.id
           _this.backImg.backImg = data.backImg
         })
      },
      submitBackImg(){
        var _this = this
        insertBackImg(_this.backImg).then(({code})=>{
          if(code==200){
           _this.dialogFormVisible = false
           _this.$message.success("更新背景信息成功")
          }
        })
      },
      getBackImg(val){
        this.backImg.backImg = val
      },
      filterMethod(value){
        var _this = this
        this.condition.current=1
        if(value.ifshow){
           if(value.ifshow[0] == true){
            this.condition.ifDisplay=1
           }else if(value.ifshow[0] == false){
            this.condition.ifDisplay=0
           }else{
            this.condition.ifDisplay=2
           }
        }
        queryList(_this.condition).then(({data})=>{
            _this.tableData=data
          },()=>{_this.tableData.list=[]})
      },
      sortChange(value){
          var _this = this
          this.condition.current=1
          if(value.prop=="createTime"){
            if(value.order=="descending"){
              _this.condition.createTimeSort="desc"
            }else if(value.order=="ascending"){
              _this.condition.createTimeSort="asc"
            }else{
              _this.condition.createTimeSort="desc"
            }
          }else if(value.prop=="num"){
            if(value.order=="descending"){
              _this.condition.clickNumSort="desc"
            }else if(value.order=="ascending"){
              _this.condition.clickNumSort="asc"
            }else{
              _this.condition.clickNumSort="desc"
            }
          }
          queryList(_this.condition).then(({data})=>{
            _this.tableData=data
          },()=>{_this.tableData.list=[]})
      },
      queryByTitle(){
        var _this = this
        _this.condition.current=1
        queryList(_this.condition).then(({data})=>{
          _this.tableData=data
        })
      },
      handleEdit(index, row) {
        console.log(index);
        this.$router.push({name:'abrandInformation',params:{id:row.id}})
      },
      deletedIds(){
        var _this  = this
        deletedIds(_this.ids,_this.condition).then(({data})=>{
          _this.tableData = data
          _this.$message.success("该组数据删除成功!")
        },()=>{_this.tableData.list=[]})
      },
      handleDelete(index) {
        var _this = this
        deleted(_this.tableData.list[index]).then(()=>{
          if((_this.tableData.totalCount%_this.condition.size==1)&&_this.tableData.totalCount!=1&&_this.condition.current==_this.tableData.totalPage){
            _this.condition.current=_this.condition.current-1
          }
          _this.$message.success("删除成功!")
          queryList(_this.condition).then(({data})=>{
            _this.tableData=data
          },()=>{_this.tableData.list=[]})
        })
      },
      addData(){
        this.$router.push({path:'brandInformation'})
      },
      changeDisplay(index){
        var _this = this
        update({id:_this.tableData.list[index].id,ifshow:!_this.tableData.list[index].ifshow}).then(({code})=>{
          if(code==200){
            _this.$message.success("更新成功!")
          }
        })
        this.tableData.list[index].ifshow=!this.tableData.list[index].ifshow
      },
      handleCurrentChange(val){
         var _this =this
         _this.condition.current = val
         queryList(_this.condition).then(({data})=>{
          _this.tableData=data
        })
      }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 this.show = true
 var _this = this
 queryList(_this.condition).then(({data})=>{
   _this.tableData=data
 })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类

</style>